export enum MailingListType {
    UNKNOWN,
    USER,
    ORGANISER
}